'use client';
import { type PropsWithChildren, useEffect, useState } from 'react';
import { ErrorBoundary, Provider } from '@rollbar/react';
import { getEnv } from '@witmetrics/utils/env';
import { NODE_ENV } from '@witmetrics/utils/constants';

export default function RollbarProvider({ children }: PropsWithChildren) {
  const [config, setConfig] = useState<{
    accessToken: string;
    environment: string;
  }>();

  useEffect(() => {
    setConfig({
      accessToken: 'b807cdbbbca74fb5aa7027b5cf301627',
      environment: getEnv(),
    });
  }, []);

  return !config || config.environment === NODE_ENV.DEVELOPMENT ? (
    <>{children}</>
  ) : (
    <Provider config={config}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Provider>
  );
}
